import classNames from "classnames";
import useDimension from "src/hooks/useDimension";
import featureImage from "../../images/feature-1.png";
import logo from "../../images/logo.png";
import Feature from "./Feature";

const PublicLayout = ({ children, rightSection = {}, leftSection }) => {
  const { width } = useDimension();

  const shouldShowLeftLayout = width > 1080;

  const showRightSideInfo = Object.keys(rightSection).length === 0;

  return (
    <div className="flex h-full w-full justify-center items-center">
      {shouldShowLeftLayout && (
        <div className="bg-primary text-white h-full w-1/2 flex justify-center items-center p-8">
          <div className="flex flex-col h-full items-center justify-center">
            <div className="font-bold text-4xl text-center">
              {leftSection.heading}
            </div>
            <img
              src={featureImage}
              alt="feature-1"
              className="mt-[55px]"
              width={"auto"}
              style={{
                maxHeight: "500px",
                height: "calc(100% - 287px)",
              }}
            />
            <div className="flex justify-center">
              <div className="flex flex-col gap-[32px] w-[70%]">
                {leftSection.features.map((feature) => {
                  return <Feature text={feature.text} />;
                })}
              </div>
            </div>
          </div>
        </div>
      )}
      <div
        className={classNames("flex justify-center items-center h-full p-6", {
          "w-1/2": shouldShowLeftLayout,
          "w-full": !shouldShowLeftLayout,
        })}
      >
        <div className="flex flex-col max-w-[550px] w-full sm:w-[60%] justify-start gap-9">
          {!showRightSideInfo && (
            <>
              <img className="w-[124px]" src={logo} alt="Your Company" />
              <div className="flex flex-col">
                <div className="text-28px font-bold">
                  {rightSection.heading}
                </div>
                <p className="text-14px text-grayishBlue font-400">
                  {rightSection.subHeading}
                </p>
              </div>
            </>
          )}
          {children}
        </div>
      </div>
    </div>
  );
};

export default PublicLayout;
